const getCurrency = (lang) => {
    return lang === 'ru-RU' ? 'RUB' : 'USD';
};
let FORMATTER_LANG = 'en-US';
const PLURALS = {
    'en-US': { decimal: 'other', one: 'one', few: 'many', many: 'many' },
    'ru-RU': { decimal: 'other', one: 'one', few: 'few', many: 'many' },
};
class Formatter {
    static registerLanguageVersion(version) {
        FORMATTER_LANG = version;
    }
    static asNumber(value) {
        return Intl.NumberFormat(FORMATTER_LANG).format(value);
    }
    static asCurrency(value) {
        return Intl.NumberFormat(FORMATTER_LANG, {
            style: 'currency',
            currency: 'USD',
        }).format(value);
    }
    static asRealCurrency(value) {
        return Intl.NumberFormat(FORMATTER_LANG, {
            style: 'currency',
            currency: getCurrency(FORMATTER_LANG),
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(value);
    }
    static asPercent(value) {
        return Intl.NumberFormat(FORMATTER_LANG, {
            style: 'percent',
        }).format(value);
    }
    static asDate(value) {
        return Intl.DateTimeFormat(FORMATTER_LANG, {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
        }).format(value);
    }
    static asTime(value) {
        return Intl.DateTimeFormat(FORMATTER_LANG, {
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
        }).format(value);
    }
    static asDateTime(value) {
        return Intl.DateTimeFormat(FORMATTER_LANG, {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
        }).format(value);
    }
    static asPlural(input, options) {
        let value = Number(input);
        for (let key in options) {
            if (!options.hasOwnProperty(key)) {
                continue;
            }
            if (/=\d+/.test(options[key])) {
                let compare = Number(options[key].substr(1));
                if (value === compare) {
                    return options[key].replace('#', Formatter.asNumber(value));
                }
            }
        }
        let plurals = PLURALS[FORMATTER_LANG];
        let type = plurals.many;
        switch (true) {
            case !(value % 1 === 0):
                type = plurals.decimal;
                break;
            case value > 10 && value < 15:
                type = plurals.many;
                break;
            case value % 10 === 1:
                type = plurals.one;
                break;
            case value % 10 > 1 && value % 10 < 5:
                type = plurals.few;
                break;
        }
        if (options.hasOwnProperty(type)) {
            return options[type].replace('#', Formatter.asNumber(value));
        }
        console.error('Invalid plural options', input, options);
        throw new Error('Invalid plural options');
    }
}
export default Formatter;
